import React from "react";
import ButtonMoreInfo from "../../../../components/buttons/secondary-buttons/ButtonMoreInfo";
import ItsmeLogoSquare from "../../../../components/logos/itsme-logo-square";
import i18next from "../../../../assets/i18n/i18n";
import "./what-is-itsme.scss";
import { Grid } from "@material-ui/core";

const WhatIsItsme = (): React.ReactElement => {
    return (
        <Grid container style={{ marginBottom: "8px" }}>
            <Grid item xs={12} className="wii wii-header">
                {i18next.t("WhatIsItsme.Header")}
            </Grid>
            <Grid container spacing={1} justifyContent="flex-start">
                <Grid item xs={1} style={{ marginRight: "8px", marginTop: "4px" }}>
                    <ItsmeLogoSquare />
                </Grid>
                <Grid item xs={6} className="wii wii-info-text">
                    <p>{i18next.t("WhatIsItsme.InfoText")}</p>
                </Grid>
                <Grid item xs>
                    <ButtonMoreInfo />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default WhatIsItsme;
